import React from 'react';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Skeleton from '@mui/material/Skeleton';

interface TableLoaderProps {
  rowDepth: number;
  cellDepth: number;
}

export const TableLoader: React.FC<TableLoaderProps> = ({ rowDepth, cellDepth }) => {
  return (
    <TableBody>
      {[...Array(rowDepth)].map((_, rowIndex) => (
        <TableRow key={rowIndex}>
          {[...Array(cellDepth)].map((_, cellIndex) => (
            <TableCell key={cellIndex}>
              <Skeleton animation="wave" height={20} />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  );
};

export default TableLoader;
